import React, { useEffect, useState } from "react";
import Accordion from "canvas-core-react/lib/Accordion";
import AccordionItem from "canvas-core-react/lib/AccordionItem";
import CheckBox from "canvas-core-react/lib/Checkbox";
import RadioButton from "canvas-core-react/lib/RadioButton";
import SecondaryButton from "canvas-core-react/lib/SecondaryButton";
import Selector from "canvas-core-react/lib/Selector";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

import * as ClientActions from "../../../Redux/actions/clientActions";
import * as CreditLineActions from "../../../Redux/actions/credit-line";
import Modal from "../../utils/customModal";
import {
  errorContainer,
  loadingHtml,
  sucessInfoModal,
} from "../../utils/functions";
import PrimaryButton from "canvas-core-react/lib/PrimaryButton";
import useApi from "../../hooks/useApi";

const defaultModal = { show: false, content: null };

const CompanyTemporal = ({ institution, closeInfo }) => {
  const [state, setState] = useState({
    data: {},
  });
  const [modal, setModal] = useState(defaultModal);

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { putApiCAll } = useApi();

  useEffect(() => {
    const getInitialData = async () => {
      setLoading();
      const response = await dispatch(
        ClientActions.getClientModules(institution.id)
      );

      await dispatch(
        CreditLineActions.getCreditLineByCif(
          institution.cif,
          institution.country.code
        )
      );

      setState({
        data: formatData(institution, response.data, t),
      });

      clearModal();
    };

    getInitialData();
  }, []);

  const { data } = state;
  const labelTextRef = "clients.profile.company.form.";

  const isUpdated = (objProp, name, className = "label-admin-client") => {
    const deepCompare = (valueA, valueB) =>
      JSON.stringify(valueA) === JSON.stringify(valueB);

    let changed = false;

    if (objProp !== "actual") {
      if (name.includes(".")) {
        const [nameProp, comparableKey, id] = name.split(".");

        if (nameProp === "services") {
          changed = !deepCompare(
            data.actual[nameProp].find((item) => item.moduleId === +id),
            data.updated[nameProp].find((item) => item.moduleId === +id)
          );
        } else {
          changed = !deepCompare(
            data.actual[nameProp].find((item) => item.accountId === +id)[
              comparableKey
            ],
            data.updated[nameProp].find((item) => item.accountId === +id)[
              comparableKey
            ]
          );
        }
      } else changed = !deepCompare(data.actual[name], data.updated[name]);
    }

    return changed ? `${className} updated-info-color` : className;
  };

  const setLoading = () => setModal({ show: true, content: loadingHtml() });

  const clearModal = () => setModal(defaultModal);

  const handleSubmit = async (approve) => {
    setLoading();
    try {
      await putApiCAll("/companies/approve-or-rejected", [
        { id: institution.company.id, approve },
      ]);

      setModal({
        show: true,
        content: sucessInfoModal(
          t("admissions.tabs.clients"),
          t("general.modal.success"),
          {
            SelBtn: {
              text: t("general.buttons.continue"),
              action: () => {
                closeInfo(true);
              },
            },
          }
        ),
      });
    } catch (err) {
      console.log(err);
      const notification = err.response.data?.notifications[0];
      const content = errorContainer("Error", notification.description, {
        cancelBtn: { text: t("general.buttons.close"), action: clearModal },
      });
      setModal({ show: true, content });
    }
  };

  return (
    <div className="company-details">
      {Object.keys(data).length > 0 && (
        <div className="row col-12 pendingDetails">
          {Object.keys(data).map((prop) => {
            const itemData = data[prop];
            const isPa = itemData.countryCode === "PA";

            return (
              <div
                className={`${data.updated ? "col-6" : "col-12"}`}
                key={prop}
              >
                <p
                  className={`edit-profile-style ${
                    prop === "updated" ? "updated-info-color" : ""
                  }`}
                >
                  {t(`temporal.${prop}`)}
                </p>
                <div className="row">
                  {mainInfoItems.map(({ value, label }) => (
                    <div className="col-6" key={value}>
                      <label className="label-admin-client">
                        {t(`${labelTextRef}${label}`)}
                      </label>
                      <input
                        className="input-admin-client input--text input-w-aux__input input--active"
                        name={value}
                        type="text"
                        value={itemData[value]}
                        readOnly={true}
                      />
                    </div>
                  ))}
                </div>
                <Accordion className="mt-4">
                  {itemData.creditLines.map((facility, idx) => (
                    <AccordionItem
                      key={`facility-${idx}`}
                      title={facility.name}
                    >
                      <div className="row">
                        <div className="col-6">
                          <label
                            className="label-admin-client"
                            style={{ marginTop: 0 }}
                          >
                            {t("clients.profile.company.facilities.number")}
                          </label>
                          <input
                            className="input-admin-client input--text input-w-aux__input input--active"
                            id="subFacilityNumber"
                            name="subFacilityNumber"
                            type="text"
                            value={facility.lineOfCreditNumber}
                            readOnly={true}
                          />
                        </div>
                        <div className="col-6">
                          <label
                            className="label-admin-client"
                            style={{ marginTop: 0 }}
                          >
                            {t("clients.profile.company.facilities.spread")}
                          </label>
                          <input
                            className="input-admin-client input--text input-w-aux__input input--active"
                            id="subFacilitySpread"
                            name="subFacilitySpread"
                            type="text"
                            value={`${facility.interestRate}%`}
                            readOnly={true}
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-6">
                          <label className="label-admin-client">
                            {t("clients.profile.company.facilities.base")}
                          </label>
                          <input
                            className="input-admin-client input--text input-w-aux__input input--active"
                            id="subFacilityBase"
                            name="subFacilityBase"
                            type="text"
                            value={facility.baseRate}
                            readOnly={true}
                          />
                        </div>
                        <div className="col-6">
                          <label className="label-admin-client">
                            {t(
                              "clients.profile.company.facilities.approvedAmount"
                            )}
                          </label>
                          <input
                            className="input-admin-client input--text input-w-aux__input input--active"
                            id="mount"
                            name="mount"
                            type="text"
                            value={`${facility.currencySymbol} ${facility.approvedAmount}`}
                            readOnly={true}
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-6">
                          <label className="label-admin-client">
                            {t(
                              "clients.profile.company.facilities.assignAccount"
                            )}
                          </label>
                          <input
                            className="input-admin-client input--text input-w-aux__input input--active"
                            id="account"
                            name="account"
                            type="text"
                            value={facility.accountNumber}
                            readOnly={true}
                          />
                        </div>
                      </div>
                    </AccordionItem>
                  ))}
                </Accordion>
                <div className="row">
                  <div className="col-6">
                    <label
                      className={isUpdated(prop, "status")}
                      style={{ marginTop: 0 }}
                    >
                      {t("clients.profile.company.form.state")}
                    </label>
                    <input
                      className="input-admin-client input--text input-w-aux__input input--active"
                      name="status"
                      type="text"
                      value={itemData.status}
                      readOnly={true}
                    />
                  </div>
                  <div className="col-6">
                    <label
                      className={isUpdated(prop, "feci")}
                      htmlFor="feci"
                      style={{ marginTop: 0 }}
                    >
                      {t("clients.profile.company.facilities.feci")}
                    </label>
                    <div className="flex-element radio-group">
                      <RadioButton
                        label={t("general.labels.yes")}
                        id="HasFeci"
                        name={`${prop}-HasFeci`}
                        disabled={true}
                        checked={itemData.feci}
                      />
                      <RadioButton
                        label={t("general.labels.no")}
                        id="HasnotFeci"
                        name={`${prop}-feciact`}
                        disabled={true}
                        checked={itemData.feci === false}
                      />
                    </div>
                  </div>
                </div>

                <div className="mb-5">
                  <div className="row">
                    {isPa && (
                      <div className="col-6">
                        <label className={isUpdated(prop, "cinu")}>
                          {t("clients.profile.company.form.cinu")}
                        </label>
                        <input
                          className="input-admin-client input--text input-w-aux__input input--active"
                          id="cinu"
                          name="cinu"
                          type="text"
                          value={itemData.cinu}
                          readOnly
                        />
                      </div>
                    )}
                    <div className={!isPa ? "col-12" : "col-6"}>
                      <label
                        className={isUpdated(prop, "codeDestinationFound")}
                      >
                        {t("clients.profile.company.form.fundDestinationCod")}
                      </label>
                      <input
                        className="input-admin-client input--text input-w-aux__input input--active"
                        id="fundDestinationCod"
                        name="fundDestinationCod"
                        type="text"
                        value={itemData.codeDestinationFound}
                        readOnly
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12">
                    <div className="loaded-module">
                      <h2 className="flex-element">
                        {t("services.options.title")}
                      </h2>
                      <h2>{t("services.options.numberApprovals")}</h2>
                    </div>
                    {itemData.services?.map(
                      ({
                        moduleId,
                        displayName,
                        hasModule,
                        numberOfApprovals,
                      }) => (
                        <div
                          key={`${moduleId}-${prop}`}
                          className="loaded-module align-items-end"
                        >
                          <CheckBox
                            name={`service-${moduleId}`}
                            label={displayName}
                            defaultChecked={hasModule}
                            disabled={true}
                            className={isUpdated(
                              prop,
                              `services.moduleId.${moduleId}`,
                              "changes"
                            )}
                          />
                          <Selector
                            placeholder={`${
                              numberOfApprovals == 100
                                ? t("services.options.globalApproval")
                                : `${numberOfApprovals}`
                            }`}
                            id={`selector-${moduleId}`}
                            label={""}
                            disabled={true}
                            className="disabled"
                          >
                            <></>
                          </Selector>
                        </div>
                      )
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <div className="loaded-module mt-3">
                      <h2>{t("general.waiver.waiver_title")}</h2>
                      <h2 style={{ width: "auto", paddingRight: 30 }}>
                        {t("general.waiver.date")}
                      </h2>
                    </div>
                    <div className="clearfix service-container margin_speacial_codition">
                      {!isPa ? (
                        <div className="loaded-module">
                          <CheckBox
                            id="waiver_extension_crc"
                            label={t("general.waiver.waiver_extension_crc")}
                            checked={itemData.creditLineCrcExtension != "null"}
                            className={isUpdated(
                              prop,
                              "creditLineCrcExtension",
                              ""
                            )}
                            disabled
                          />
                          <div className="ml-auto input small2">
                            <input
                              type="text"
                              className="input--text input--active"
                              value={formatDate(
                                itemData.creditLineCrcExtension
                              )}
                              disabled
                            />
                          </div>
                        </div>
                      ) : null}

                      {waivers.map(({ name, label }) => (
                        <div className="loaded-module" key={name}>
                          <CheckBox
                            id="waiver_extension_usd"
                            label={t(`general.waiver.${label}`)}
                            checked={itemData[name] != "null"}
                            disabled
                            className={isUpdated(prop, name, "")}
                          />
                          <div className="ml-auto input small2">
                            <input
                              type="text"
                              className="input--text input--active"
                              value={formatDate(itemData[name])}
                              disabled
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                {/*     <div className="row">
         <div className="col-12">
           <div className="loaded-module">
             <h2 className="flex-element">
               {t("general.special_codition.title")}
             </h2>
             <h2></h2>
           </div>
           <div className="loaded-module">
             <h2 className="flex-element"></h2>
             <h2>{t("general.special_codition.days")}</h2>
           </div>
           <div className="clearfix service-container margin_speacial_codition">
             {getSpecialConditionTemp()}
           </div>
         </div>
       </div>  */}
              </div>
            );
          })}
          <div className="form-actions clearfix">
            <SecondaryButton
              id={`back-btn`}
              className="accept"
              onClick={() => closeInfo()}
            >
              {t("general.buttons.back")}
            </SecondaryButton>
            <SecondaryButton
              className="accept"
              onClick={() => handleSubmit(false)}
            >
              {t("general.buttons.rejected")}
            </SecondaryButton>
            <PrimaryButton onClick={() => handleSubmit(true)}>
              {t("general.buttons.approve")}
            </PrimaryButton>
          </div>
        </div>
      )}
      <Modal show={modal.show}>{modal.content}</Modal>
    </div>
  );
};

export default CompanyTemporal;

const mainInfoItems = [
  {
    value: "name",
    label: "name",
  },
  {
    value: "businessId",
    label: "id",
  },
  { value: "updatedBy", label: "updatedBy" },
  { value: "action", label: "proposedAction" },
];

const formatData = (institution, services, t) => {
  const isUpdating =
    institution.recordTmps[0].data !== null ||
    institution.recordTmps[1].data !== null ||
    institution.recordTmps[2].data !== null;

  const statusRef =
    institution?.recordTmps[0]?.data?.status || institution?.company?.status;

  const getFacilityName = (overdraft, currency) => {
    return `Sub-Facility de ${overdraft ? "sobregiro" : "Reverse"} ${currency}`;
  };

  const orderedFacilities = institution.company.facilityResponse.reduce(
    (
      acc,
      {
        accountId,
        currencyCode,
        lineOfCreditNumber,
        interestRate,
        baseRate,
        approvedAmount,
        currencyDetail: { currencySymbol },
        accountNumber,
        isOverdraftLine,
      }
    ) => {
      const position = currencyCode === "USD" ? 2 : 0;
      const isOverdraft = isOverdraftLine ? 1 : 0;

      acc[position + isOverdraft] = {
        accountId,
        currencyCode,
        lineOfCreditNumber,
        interestRate,
        baseRate,
        approvedAmount,
        currencySymbol,
        accountNumber,
        isOverdraftLine,
        name: getFacilityName(isOverdraftLine, currencyCode),
      };
      return acc;
    },
    {}
  );

  const data = {
    actual: {
      name: institution.name,
      businessId: institution.businessId,
      updatedBy: institution.company.createBy,
      action: !isUpdating
        ? t("temporal.actions.update")
        : t("temporal.actions.create"),
      creditLines: Object.keys(orderedFacilities).map((key) => ({
        ...orderedFacilities[key],
      })),
      status: t(`general.states.${institution.company.status}`),
      feci: institution.company.exemptFeci,
      codeCinu: institution.company?.codeCinu,
      codeDestinationFound: institution.company?.codeDestinationFound,
      services: services.map(({ hasModule, numberOfApprovals, module }) => ({
        code: module.code,
        moduleId: module.id,
        displayName: module.displayName,
        hasModule,
        numberOfApprovals,
      })),
      countryCode: institution?.country?.code,
      creditLineCrcExtension: institution.creditLineCrcExtension,
      creditLineUsdExtension: institution.creditLineUsdExtension,
      creditFileReviewExtension: institution.creditFileReviewExtension,
      kycFileReviewExtension: institution.kycFileReviewExtension,
    },
  };

  if (isUpdating) {
    const validatedWaiverdata = (checkValue, value) => {
      const waiversData = institution.recordTmps[2]?.data || {};
      const isUpdated = waiversData[checkValue] !== undefined;

      return !isUpdated
        ? data.actual[value]
        : waiversData[checkValue]
        ? waiversData[value]
        : "null";
    };

    let updatedCreditLines;

    if (!institution.recordTmps[0]?.data?.creditLines)
      updatedCreditLines = data.actual.creditLines;
    else {
      const objectUpdatedCredit = JSON.parse(
        institution.recordTmps[0].data.creditLines
      ).reduce(
        (
          acc,
          {
            accountCurrency,
            accountNumber,
            approvedAmount,
            baseRate,
            interestRate,
            isOverdraftLine,
            subFacilityNumber,
          }
        ) => {
          const position = accountCurrency === "USD" ? 2 : 0;
          const isOverdraft = isOverdraftLine ? 1 : 0;

          acc[position + isOverdraft] = {
            currencyCode: accountCurrency,
            lineOfCreditNumber: subFacilityNumber,
            interestRate,
            baseRate,
            approvedAmount,
            currencySymbol: accountCurrency === "USD" ? "$" : "₡",
            accountNumber,
            isOverdraftLine,
            name: getFacilityName(isOverdraftLine, accountCurrency),
          };
          return acc;
        },
        {}
      );

      updatedCreditLines = Object.keys(objectUpdatedCredit).map((key) => ({
        ...objectUpdatedCredit[key],
      }));
    }

    data.updated = {
      name: institution.name,
      businessId: institution.businessId,
      updatedBy: institution.company.createBy,
      action: "Modificación",
      creditLines: updatedCreditLines,
      status: t(`general.states.${statusRef}`),
      feci: institution.recordTmps[0]?.data?.exemptFeci ?? data.actual.feci,
      codeCinu:
        institution.recordTmps?.[0]?.data?.codeCinu ?? data.actual.codeCinu,
      codeDestinationFound:
        institution.recordTmps[0]?.data?.codeDestinationFound ??
        data.actual.codeDestinationFound,
      services: data.actual.services.map((service) => {
        const newData = !!institution.recordTmps[1]?.data?.modules;
        if (!newData) return service;

        const updatedData = JSON.parse(
          institution.recordTmps[1]?.data?.modules
        ).find((updatedService) => updatedService.id === service.moduleId);

        const serviceIsUpdated = !!updatedData;

        return {
          ...service,
          hasModule: serviceIsUpdated,
          numberOfApprovals:
            updatedData?.numberOfApprovals ?? service.numberOfApprovals,
        };
      }),
      creditLineCrcExtension: validatedWaiverdata(
        "checkCreditLineCrcExtension",
        "creditLineCrcExtension"
      ),
      creditLineUsdExtension: validatedWaiverdata(
        "checkCreditLineUsdExtension",
        "creditLineUsdExtension"
      ),
      creditFileReviewExtension: validatedWaiverdata(
        "checkCreditFileReviewExtension",
        "creditFileReviewExtension"
      ),
      kycFileReviewExtension: validatedWaiverdata(
        "checkKycFileReviewExtension",
        "kycFileReviewExtension"
      ),
    };
  }
  return data;
};

const formatDate = (value) => {
  return value != "null"
    ? `${new Date(value).getUTCDate()}/${
        new Date(value).getUTCMonth() + 1
      }/${new Date(value).getUTCFullYear()}`
    : "";
};

const waivers = [
  { label: "waiver_extension_usd", name: "creditLineUsdExtension" },
  { label: "waiver_extension_cred", name: "creditFileReviewExtension" },
  { label: "waiver_extension_kyc", name: "kycFileReviewExtension" },
];
